import React from 'react';
import PropTypes from 'prop-types';

/**
 * FormCheckbox component for boolean inputs
 * Supports label, error state, and disabled state
 */
const FormCheckbox = ({
  label,
  checked,
  onChange,
  error,
  disabled = false,
  required = false,
  className = '',
  ...props
}) => {
  return (
    <div className={['tw-flex tw-flex-col tw-gap-1.5', className].filter(Boolean).join(' ')}>
      <div className="tw-flex tw-items-center tw-gap-2">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="tw-w-4 tw-h-4 tw-rounded-sm tw-border-slate-300 tw-text-blue-600 focus:tw-ring-2 focus:tw-ring-blue-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-cursor-pointer"
          {...props}
        />

        {label && (
          <label className="tw-text-sm tw-font-medium tw-text-slate-700 tw-cursor-pointer tw-flex tw-items-center">
            {label}
            {required && <span className="tw-text-red-500 tw-ml-1">*</span>}
          </label>
        )}
      </div>

      {error && (
        <p className="tw-text-xs tw-text-red-600 tw-font-medium">{error}</p>
      )}
    </div>
  );
};

FormCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
};

export default FormCheckbox;
